/* global WebView, ViewController */


var safeadminController = new ViewController({
    directory : "views/safeadmin",
    name: "safeadmin",
    container: "main",
    route: "safeadmin"
}) ;

safeadminController.prepareDataOnEnter = function(data, callback){
    callback(null, {
        safes: []
    }) ;
} ;

safeadminController.onCreate = function(){
    var v = new WebView("views/safeadmin",  "createSafePopup") ;
    
    v.on("cancel", function(){ v.close() ;}) ;
        
    v.openInPopup();
    v.on("validate", function(){
        v.checkForm(function(err, formOk){
            if(err || !formOk){
                return;
            }

            var data = v.getData() ;

            var partner = {
                name: data.partner_name,
                siret: data.partner_siret,
            };
            var safe = {
                name: data.safe_name,
                databases: [ data.safe_database ]
            };

            v.longTask(function(done){
                this.api.safeadmin.createSafe(data.password, partner, safe, function(err, createdSafe){
                    if(err){ return done(err) ;}
                    done() ;

                    WebView.info(WebView.tr("safeadmin.safeCreatedWithSuccess")) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


safeadminController.onSearch = function(){
    var v = new WebView("views/safeadmin",  "searchSafePopup") ;
    
    v.on("cancel", function(){ v.close() ;}) ;
        
    v.openInPopup({
        size: "medium"
    });
    v.on("searchBySiret", function(){
        var data = v.getData() ;

        v.longTask(function(done){
            this.api.safeadmin.getSafesByPartnerSiret(data.password, data.partner_siret, function(err, safes){
                if(err){ return done(err) ;}

                this.data.safes = safes ;

                this.view.render() ;

                v.close() ;

                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;

    v.on("searchByDatabase", function(){
        var data = v.getData() ;

        v.longTask(function(done){
            this.api.safeadmin.getSafesByDatabase(data.password, data.safe_database, function(err, safes){
                if(err){ return done(err) ;}

                this.data.safes = safes ;

                this.view.render() ;

                v.close() ;

                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;

    v.on("searchByName", function(){
        var data = v.getData() ;

        v.longTask(function(done){
            this.api.safeadmin.getSafesByPartnerName(data.password, data.safe_name, function(err, safes){
                if(err){ return done(err) ;}

                this.data.safes = safes ;

                this.view.render() ;

                v.close() ;

                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = safeadminController ;